// extracted by mini-css-extract-plugin
module.exports = {"line":"separator_line__36XSA","space8":"separator_space8__3rY40","space16":"separator_space16__1SeXP","space24":"separator_space24__2v4zE"};